import {PoiElementType} from "../utils/PoiType";

export const OSMElementTypeToPoiElementType = {
    N: PoiElementType.NODE,
    R: PoiElementType.RELATION,
    W: PoiElementType.WAY
};
import {PoiElementType} from "../utils/PoiType";

export const OSMElementTypeToPoiElementType = {
    N: PoiElementType.NODE,
    R: PoiElementType.RELATION,
    W: PoiElementType.WAY
};
